// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato);"]);
// Module
exports.push([module.id, ".LogOutButton[data-v-a53056e4]{width:100%;height:3rem;background:#F0F0F0;cursor:pointer}.LogOutButton[data-v-a53056e4]:hover{background:#f5f5f5}.LogOutButton__text[data-v-a53056e4]{line-height:3rem;font-size:1.2rem;text-align:center;display:flex;align-items:center;justify-content:center}.LogOutButton__text-arrow[data-v-a53056e4]{margin-left:0.8rem;vertical-align:middle}\n", ""]);
// Exports
module.exports = exports;
